import { Component, OnInit } from '@angular/core';
import { PasswordService } from '../password.service';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';

@Component({
  selector: 'app-password',
  templateUrl: './password.component.html',
  styleUrls: ['./password.component.css']
})
export class PasswordComponent implements OnInit {
  password = '';
  status = '';
  constructor(private passwordService: PasswordService, private http: HttpClient) { }

  ngOnInit() {
  }

  submitPassword() {
    const body = new HttpParams()
      .set('password', this.password);
    this.http.post('https://curtisporter.com/unlock_service/', body.toString(),
      {
        headers: new HttpHeaders()
          .set('Content-Type', 'application/x-www-form-urlencoded')
     }).subscribe(
       val => {
         console.log("POST call successful value returned in body", val);
       },
       response => {
         console.log("POST call resulted in error", response);
       },
       () => {
         console.log("POST observable complete");
       }
     );
     console.log('Posted password ' + this.password + ' to unlock service');
     status = 'Unlocked';
  }

}
